export default __webpack_public_path__ + "static/media/store-3.a0323969.jpg";